import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: false,
})
export class SnackbarComponent {

  jsonDataSet: any;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    this.jsonDataSet = require('../../../assets/i18n/en.json');
  }

  //TODO :  Need to update this after testing 
  get getSnackBarDesign() {

    switch (this.data.snackType) {
      case 'success':
        return {
          type: this.data.snackType,
          icon: 'check_circle_outline',
          iconDesign: 'icon-success',
          stripDesign: 'successStrip',
          messageAlign: 'align-success-message'
        };
      case 'error':
        if (this.data.message === this.jsonDataSet.NotificationEngine.UserPreference.SaveFail) {
          return {
            type: this.data.snackType,
            icon: 'error_outline',
            iconDesign: 'icon-error',
            stripDesign: 'errorStrip',
            messageAlign: 'align-error-message'
          }
        }
        else {
          return {
            type: this.data.snackType,
            icon: 'error_outline',
            iconDesign: 'icon-error',
            stripDesign: 'errorStrip',
            messageAlign: 'align-message'
          };
        }
      case 'warn':
        return {
          type: this.data.snackType,
          icon: 'warning',
          iconDesign: 'icon-warning',
          stripDesign: 'warningStrip',
          messageAlign: 'align-message'
        };
      case 'info':
        return {
          type: this.data.snackType,
          icon: 'info',
          iconDesign: 'icon-information',
          stripDesign: 'informationStrip',
          messageAlign: 'align-message'
        };
      default:
        return {
          type: this.data.snackType,
          icon: 'check',
          iconDesign: 'icon-success',
          stripDesign: 'successStrip',
          messageAlign: 'align-message'
        };
    }
  }

  closeSnackbar() {
    this.data.snackBar.dismiss();
  }

}
